module.exports = __webpack_public_path__ + "static/equipoutdoors_logo-7e849e8599847bdb49e1007cb3961af3.webp";